import React from 'react'
import { Logo } from '../components/Logo'
import { ComidaDay } from './ComidaDay'
import { PrecioDay } from './PrecioDay'

export const MenuUnificadoDay = () => {
  return (
    <div className="App">
      <Logo></Logo>
      <PrecioDay></PrecioDay>
      <ComidaDay></ComidaDay>
    </div>
  )
}
